import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Grid, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { SignUpForm } from './signUpForm';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { SignUpFormValues } from '../common/interfaces';
import { ErrorTypography } from '../common/errorTypography';


interface SignUpViewProps {
    submitSignUp: (data: SignUpFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    watch: UseFormMethods['watch'];
    returnUrl: string;
    loading: boolean;
    serverError?: string;
    setActualDate: (date: string) => void;
}

export const SignUpView = ({ 
    submitSignUp, 
    fieldsErrors,
    setActualDate,
    handleSubmit,
    register,
    watch,
    returnUrl,
    loading,
    serverError
} : SignUpViewProps) => {
    const { t } = useTranslation();

    return (
        <StyledContainer>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SignUpForm 
                        submitSignUp={submitSignUp}
                        fieldsErrors={fieldsErrors}
                        handleSubmit={handleSubmit}
                        register={register}
                        watch={watch}
                        loading={loading}
                        setActualDate={setActualDate}
                    />
                </Grid>
                {serverError
                    && <Grid container item xs={12}>
                        <ErrorTypography serverError={serverError} />
                    </Grid>
                }
                {returnUrl
                    && <Grid container item direction='row' alignItems='center' xs={12}>
                        <ExistingAccount>
                            {t('alreadyHaveAnAccount')}
                        </ExistingAccount>
                        <Button 
                            component={Link}
                            to={`/login?ReturnUrl=${returnUrl}`}
                            fullWidth
                            variant='outlined'>
                            {t('signIn')}
                        </Button>
                    </Grid>
                }
            </Grid>
        </StyledContainer>
    );
};

const StyledContainer = styled(Container)`
    margin-top: 40px;
    font: Roboto;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    font-family: sans-serif;
`;

const ExistingAccount = styled.div`
    font-size: 15px;
    color: #888888;
    margin: 10px auto 10px auto;
`;
